import * as preact from "preact";
import { $$ } from "../../Core/Common";
import { DataPanel, IDataPanelProps } from "../DataPanel/DataPanel";
import { TextBox } from "../TextBox/TextBox";

import Location = EventLibrary.Model.Location;

export interface ILocationSelectorProps extends IDataPanelProps<Location>
{
    Simple?: boolean;
    Descriptor?: string;
}

export class LocationSelector extends DataPanel<Location, ILocationSelectorProps>
{
    private _gAutoComplete: google.maps.places.Autocomplete;
    //private _place: google.maps.places.PlaceResult;
    private _txtLocation: TextBox;
    private _formattedAddress: string;
    private _locationJson: string;
    private _googlePlaceId: string;
    private _placeId: string;
    private _location: google.maps.LatLng;
    private _pnlMap: HTMLElement;
    private _marker: google.maps.Marker;

    constructor(props: ILocationSelectorProps)
    {
        super(props);
    }

    public override componentDidMount(): void
    {
		//just ignore google maps if running off line
		if(window.google)
        {
            this._gAutoComplete = new google.maps.places.Autocomplete(this._txtLocation.getInputElement() as HTMLInputElement);
			google.maps.event.addListener(this._gAutoComplete, "place_changed", this._onPlaceChanged.bind(this));
		}
        super.componentDidMount();
    }

    private _onPlaceChanged(args): void
    {
        var place = this._gAutoComplete.getPlace();
        //this._place = place;
        this._formattedAddress = place.formatted_address;
        this._locationJson = $$.serialize(place.address_components);
        this._googlePlaceId = place.place_id;
        var geometry = place.geometry;
        if (geometry)
        {
            this._location = geometry.location;
            if (this._pnlMap)
            {
                var map = new google.maps.Map(this._pnlMap, {
                    zoom: 12, center: geometry.location, panControl: false,
                    streetViewControl: false
                });
                $(this._pnlMap).slideDown();
                this._marker = new google.maps.Marker({ position: geometry.location, map: map, draggable: true });
            }
        }
    }

    public override getData(): Location
    {
        var displayName = this._txtLocation.getValue();
        if (!displayName && !this._placeId)
        {
            return null;
        }

        let position: google.maps.LatLng;
        if (this.props.Simple)
        {
            position = this._location;
        }
        else
        {
            position = (this._marker as any).position as google.maps.LatLng;
        } 

        var data = {
            Name: displayName,
            Latitude: position.lat(),
            Longitude: position.lng(),
            FormattedAddress: this._formattedAddress,
            Id: parseInt(this._placeId,10) || null,
            LocationJson: this._locationJson,
            GooglePlaceId: this._googlePlaceId
        } as Location;
        return data;
    }

    public override setData(data)
    {
        if (!data)
        {
            this._placeId = null;
            this._txtLocation.setValue(null);

            if (!this.props.Simple)
            {
                this._marker = null;
                $$.hide(this._pnlMap);
            }
            return;
        }

        this._placeId = data.Id;
        this._txtLocation.setValue(data.Name);
        this._formattedAddress = data.FormattedAddress;
        this._locationJson = data.LocationJson;
        this._location = google && new google.maps.LatLng(data.Latitude, data.Longitude);
        this._googlePlaceId = data.GooglePlaceId;

        if (!this.props.Simple && google)
        {
            $$.show(this._pnlMap);
            var map = new google.maps.Map(this._pnlMap,
                {
                    zoom: 12,
                    center: this._location,
                    panControl: false,
                    streetViewControl: false
                }
            );
            
            this._marker = new google.maps.Marker({
                position: this._location,
                map: map,
                draggable: true
            });
        }
    }

    public render()
    {
        return (
            <div style={{ width: "550px" }} ref={(ref) => this._registerContainer(ref)}>
                <TextBox Descriptor={this.props.Descriptor} ref={(ref) => this._txtLocation = ref} style={{ width: "100%", boxSizing: "border-box" }} DescriptorTop="-8px" />
                {
                    this.props.Simple ? null : (
                        <div ref={(ref) => this._pnlMap = ref} style={{ width: "100%", boxSizing:"border-box", height: "175px", display: "none", overflow: "hidden" }}></div>
                )}
            </div>);
    }
}